import Timestamp from "components/Timestamp";
import TableCellText from "ds/components/Table/Row/CellText";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";

import { PersonalApiKey } from "../../gql";

const PersonalApiKeysTableLastUsedCell = ({
  item: apiKey,
  ...cellProps
}: TableSimpleCellProps<PersonalApiKey>) => {
  return (
    <TableSimpleCell {...cellProps}>
      {apiKey.lastUsedAt && <Timestamp variant="p-body3" timestamp={apiKey.lastUsedAt} />}
      {!apiKey.lastUsedAt && <TableCellText>Never used</TableCellText>}
    </TableSimpleCell>
  );
};

export default PersonalApiKeysTableLastUsedCell;
